import React from 'react';
import ReactDOM from 'react-dom';
import loadTranslations from 'js/localeSetup';

import BreadcrumbsList from './BreadcrumbsList';
import './breadcrumbStyleNew.less';

function BreadcrumbsNew({
  expandable,
  position,
  breadcrumbs,
  twoRows,
  sidePadding,
}) {
  return (
    <BreadcrumbsList
      expandable={expandable}
      breadcrumbs={breadcrumbs}
      position={position}
      twoRows={twoRows}
      sidePadding={sidePadding}
    />
  );
}

export default BreadcrumbsNew;

(async () => {
  const rootElement = document.getElementById('mobileCategoryTags');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(
      <BreadcrumbsList
        breadcrumbs={window.__INITIAL_STATE__.subcategories.filter(
          (bc) => bc.online
        )}
        position="category"
        expandable
        twoRows
      />,
      rootElement
    );
  }
})();
